import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, KeyRound, Menu, X } from "lucide-react";
import { LogoLockup } from "@/components/brand";
import { BRAND } from "@/constants/states";

const LINKS = [
  { id: "about", num: "01", label: "About", testId: "nav-link-about" },
  { id: "services", num: "02", label: "Services", testId: "nav-link-services" },
  { id: "process", num: "03", label: "Process", testId: "nav-link-process" },
  { id: "testimonials", num: "04", label: "Voices", testId: "nav-link-testimonials" },
  { id: "contact", num: "05", label: "Contact", testId: "nav-link-contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="nav-header"
      className="fixed top-0 left-0 right-0 z-50 px-4 sm:px-8 py-3.5 backdrop-blur-xl bg-[#04111D]/85 border-b border-[#C9A24B]/15"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <LogoLockup />
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={l.testId}
              className="group font-data text-[11px] tracking-[0.2em] uppercase text-[#8EA3B0] hover:text-[#E8C87A] transition-colors duration-300"
            >
              <span className="text-[#C9A24B]/70 mr-1">{l.num}</span>
              <span className="border-b border-transparent group-hover:border-[#C9A24B]/60 pb-0.5 transition-colors duration-300">
                {l.label}
              </span>
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <a
            href={BRAND.phoneHref}
            data-testid="nav-phone-button"
            className="flex items-center gap-2 text-xs font-semibold tracking-wider text-[#D4DFE6] hover:text-[#E8C87A] transition-colors duration-300"
          >
            <span className="w-2 h-2 rounded-full bg-[#C9A24B] pulse-dot" />
            <Phone className="w-3.5 h-3.5 text-[#C9A24B]" />
            {BRAND.phone}
          </a>
          <a
            href="#contact"
            data-testid="nav-cta-referral"
            className="rounded-full bg-[#C9A24B] text-[#04111D] text-xs uppercase tracking-[0.16em] font-bold px-5 py-2.5 hover:bg-[#E8C87A] hover:shadow-[0_0_24px_rgba(201,162,75,0.45)] transition-all duration-300"
          >
            Initiate Referral
          </a>
          <Link
            to="/admin"
            data-testid="nav-admin-link"
            aria-label="Admin portal"
            className="p-2 rounded-full border border-[#C9A24B]/25 text-[#8EA3B0] hover:text-[#E8C87A] hover:border-[#C9A24B]/60 transition-colors duration-300"
          >
            <KeyRound className="w-4 h-4" />
          </Link>
        </div>
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          className="lg:hidden p-2 text-[#E8C87A]"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden mt-3 pb-3 border-t border-[#C9A24B]/15 pt-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`${l.testId}-mobile`}
              onClick={() => setOpen(false)}
              className="font-data text-xs tracking-[0.2em] uppercase text-[#D4DFE6]"
            >
              <span className="text-[#C9A24B] mr-2">{l.num}</span>
              {l.label}
            </a>
          ))}
          <a href={BRAND.phoneHref} className="flex items-center gap-2 text-sm text-[#E8C87A] font-semibold">
            <Phone className="w-4 h-4" /> {BRAND.phone}
          </a>
          <Link to="/admin" className="flex items-center gap-2 text-xs text-[#8EA3B0] uppercase tracking-widest">
            <KeyRound className="w-3.5 h-3.5" /> Admin Portal
          </Link>
        </div>
      )}
    </header>
  );
};
